import Image from "next/image";
import Skeleton from "react-loading-skeleton";
import InitialCard from "../common/InitialCard";
import Locations from "./locations";
import UserLoginSwitch from "../auth/UserLoginSwitch";
import styles from "./index.module.css";
import {
  searchIcon,
  cartIcon,
  searchWhiteIcon,
  closeIcon,
  brandlogo,
} from "../../assets";

const StoreHeader = ({
  headerRef,
  headerClassName,
  showSearchBar,
  isSticky,
  isAtTop,
  searchFocus,
  storePath,
  hasSearch,
  handleLogoClick,
  isSwitching,
  organisation,
  accessPoints,
  accessPointId,
  hasTyped,
  isHomePage,
  pastHomeSearch,
  searchTerm,
  searchInputRef,
  handleSearch,
  cancelSearch,
  setSearchFocus,
  setHasTyped,
  urlWithSearchQuery,
  navLocation,
  onSeeAllSearchResults,
  modal,
  storeBoxLocationChange,
  isPageMode,
  showCart,
  cartCount,
  onLogout,
  handleLoginClick,
}) => {
  return (
    <header
      ref={headerRef}
      className={`${headerClassName} ${
        showSearchBar || isSticky ? styles.stickyHeader : ""
      }`}
      style={
        showSearchBar || isSticky ? { top: isAtTop ? "" : "0" } : { top: "" }
      }
    >
      <div className={styles.headerContent}>
        {!searchFocus && storePath !== "market-place" && (
          <div
            className={`${styles.topimageinitials} ${
              hasSearch ? styles.searchingActive : ""
            }`}
            onClick={handleLogoClick}
          >
            {isSwitching ? (
              <>
                <div
                  style={{
                    width: "5rem",
                    height: "5rem",
                    borderRadius: "50%",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "0.5rem",
                  }}
                >
                  <Skeleton cirle height={"5rem"} width={"5rem"} />
                </div>
                <div className={styles.handleCard}>
                  <div className={styles.handleName}>
                    <Skeleton width={150} height={20} />
                  </div>
                  <div className={styles.storeFront}>
                    <Skeleton width={100} height={16} />
                  </div>
                </div>
              </>
            ) : (
              <>
                <InitialCard
                  image={organisation?.logoUrl ?? ""}
                  name={organisation?.orgName ?? ""}
                />
                <div className={styles.handleCard}>
                  <div className={styles.handleName}>
                    {organisation?.orgName ?? ""}
                  </div>
                  <div className={styles.storeFront}>
                    {(() => {
                      const safePoints = accessPoints || [];
                      const point = safePoints.find(
                        (p) => p.accessPointId === accessPointId,
                      );

                      if (safePoints.length === 0) {
                        return organisation?.settings?.storeName || "StoreFront";
                      }

                      if (safePoints.length === 1) {
                        return organisation?.settings?.storeName || "StoreFront";
                      }

                      if (point?.name === "Main Entrance") {
                        return organisation?.settings?.storeName || "StoreFront";
                      }

                      return `Location: ${point?.name || "Unknown Location"}`;
                    })()}
                  </div>
                </div>
              </>
            )}
          </div>
        )}

        {!searchFocus && storePath === "market-place" && (
          <div className={`${styles.marketPlaceHeader} ${
              hasSearch ? styles.searchingActive : ""
            }`}
            >
            {isSwitching ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <div
                  style={{
                    width: "5rem",
                    height: "5rem",
                    borderRadius: "50%",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Skeleton circle height="5rem" width="5rem" />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "6px",
                  }}
                >
                  <Skeleton width={150} height={20} />
                  <Skeleton width={100} height={16} />
                </div>
              </div>
            ) : (
              <div className={styles.brandImagecontainer} onClick={handleLogoClick}>
                <Image
                  src={brandlogo}
                  alt="circle plug brand logo"
                  className={styles.brandlogo}
                  quality={1}
                />
              </div>
            )}
          </div>
        )}

        {(showSearchBar || isSticky || searchFocus || hasTyped) &&
          (!isHomePage || searchFocus || hasTyped || pastHomeSearch) && (
            <div
              className={styles.searchContainer}
              style={{
                width: "auto",
                ...(searchFocus || searchTerm.trim() !== ""
                  ? { display: "block" }
                  : {}),
              }}
            >
              <form
                className={styles.searchbar}
                onSubmit={(e) => {
                  e.preventDefault();
                  if (searchTerm.trim()) {
                    urlWithSearchQuery(searchTerm);
                    if (searchFocus) setSearchFocus(false);
                  }
                }}
              >
                <input
                  placeholder="Search a product..."
                  ref={searchInputRef}
                  value={searchTerm}
                  onChange={(e) => handleSearch(e)}
                />

                {hasTyped ? (
                  <span
                    type="button"
                    className={styles.cancelSearch}
                    onClick={(e) => {
                      cancelSearch(e);
                    }}
                  >
                    {closeIcon}
                  </span>
                ) : (
                  <button
                    type="submit"
                    className={`${styles.searchButton} ${styles.ovalButton}`}
                  >
                    {searchWhiteIcon} Search
                  </button>
                )}
              </form>
              {searchTerm.trim() !== "" &&
                storePath !== "market-place" &&
                navLocation === "marketplace" && (
                  <div
                    className={styles.searchPrompt}
                    style={{
                      paddingTop: ".5rem",
                      paddingLeft: "1rem",
                      color: "#0e86d4",
                      fontSize: "1.2rem",
                      cursor: "pointer",
                    }}
                    onClick={onSeeAllSearchResults}
                  >
                    <p>See all search results from all our stores?..</p>
                  </div>
                )}
            </div>
          )}

        {!searchFocus && (
          <div
            className={`${styles.locationCartBox} ${
              hasSearch ? styles.searchingActive : ""
            }`}
          >
            {(modal === true && showSearchBar) || !showSearchBar ? (
              <Locations
                locations={accessPoints}
                accessPointId={accessPointId}
                handleLocationChange={storeBoxLocationChange}
                storePath={storePath}
              />
            ) : null}

            {(showSearchBar || isSticky) && !modal && (
              <div
                className={styles.searchIconOnly}
                onClick={() => {
                  setSearchFocus(true);
                  setHasTyped?.(true);
                }}
              >
                {searchIcon}
              </div>
            )}

            <div
              className={styles.topCart}
              onClick={() => {
                if (!isPageMode) showCart();
              }}
            >
              <div className={styles.topCartIcon}>
                <span>{cartIcon}</span>
                {cartCount > 0 && <sup className={styles.cartCount}>{cartCount}</sup>}
              </div>
              <div className={styles.topCartText}>Cart</div>
            </div>

            <div className="header-login">
              <UserLoginSwitch
                onLogout={onLogout}
                handleLoginClick={handleLoginClick}
                dropdownMode={true}
                storePath={storePath}
                organisation={organisation}
                accessPointId={accessPointId}
              />
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default StoreHeader;
